import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import { EshopTabs } from '@/components/eshop/EshopTabs'
import { Skeleton } from '@/components/ui/skeleton'
import { StorefrontTokens } from '@/containers/StorefrontTokens/StorefrontTokens'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { Collection } from '@/interfaces/Collection'
import { StorefrontToken } from '@/interfaces/eshop'

export default function EshopTokensPage() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'eshop',
  })

  const {
    data: tokens,
    isLoading,
    mutate,
  } = useSWR<Collection<StorefrontToken>>(
    '/api/v2/storefront-tokens',
    apiFetcher,
  )

  useSetPageHeader({
    breadcrumbs: [
      { href: '/eshop/tokens', children: t('title') },
      { href: '/eshop/tokens', children: t('tokens.title') },
    ],
  })

  return (
    <>
      <title>{t('title') + ', ' + t('tokens.title')}</title>
      <div className="mx-auto w-full max-w-[1280px]">
        <EshopTabs />
      </div>

      {isLoading && (
        <div className="mx-auto w-full max-w-[1280px] space-y-4">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-40 w-full rounded-lg" />
        </div>
      )}

      {tokens && (
        <StorefrontTokens tokens={tokens.data} mutate={() => mutate()} />
      )}
    </>
  )
}
